import { Empty, Typography, Tag, Tooltip } from "antd";
import Table from "../Tables/Table";

const { Text } = Typography;

const AcademicProgramsTab = ({ institution }) => {
  const { academic_programs = [] } = institution;

  console.log("Institution", institution.academic_programs);

  if (academic_programs.length === 0) {
    return (
      <div className="py-8">
        <Empty description="No academic programs found for this institution." />
      </div>
    );
  }

  // Define columns
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Program Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Program Code",
      dataIndex: "program_code",
      key: "program_code",
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "active" ? "green" : "volcano"}>{status}</Tag>
      ),
    },
  ];

  // Add specializations as expandable rows
  const expandedRowRender = (record) => {
    const specialisations = Array.isArray(record.specialisations)
      ? record.specialisations
      : [];

    if (specialisations.length === 0) {
      return <Text type="secondary">No specialisations available.</Text>;
    }

    console.log("specialization length", specialisations);

    return (
      <Table
        columns={[
          {
            title: "#",
            dataIndex: "index",
            key: "index",
            width: 150,
            render: (_, __, index) => index + 1,
          },
          {
            title: "Specialisation Name",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
            render: (text) => {
              const isEmpty = !text?.trim();
              const displayText = isEmpty ? "N/A" : text;

              return isEmpty ? (
                <div style={{ textAlign: "left", color: "#888" }}>
                  {displayText}
                </div>
              ) : (
                <Tooltip title={text}>
                  <div
                    style={{
                      maxWidth: 250,
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {text}
                  </div>
                </Tooltip>
              );
            },
          },
        ]}
        rows={specialisations.map((s) => ({ ...s, key: s.id }))}
        pagination={false}
        size="small"
        bordered
      />
    );
  };

  return (
    <div className="pt-5">
      <Table
        columns={columns}
        rows={academic_programs.map((p) => ({ ...p, key: p.id }))}
        pagination={{ pageSize: 5 }}
        bordered
        expandable={{ expandedRowRender }}
      />
    </div>
  );
};

export default AcademicProgramsTab;
